import { State, state as defaultState } from '@/store/modules/campaign/state';
import { actions } from '@/store/modules/campaign/actions';
import { mutations } from '@/store/modules/campaign/mutations';
import { getters } from '@/store/modules/campaign/getters';
import { Module } from 'vuex';
import { RootState } from '@/store/state';

export default {
  namespaced: true,
  state: defaultState(),
  actions,
  mutations,
  getters
} as Module<State, RootState>;
